import React from 'react';
export function CheckHiFiIllustration() {
  return /*#__PURE__*/React.createElement("svg", {
    style: {
      fill: '#098972'
    },
    "data-testid": "check-hifi-illustration",
    role: "img",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: "96",
    height: "96",
    viewBox: "0 0 96 96",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05263 48C5.05263 24.2809 24.2809 5.05263 48 5.05263C71.7191 5.05263 90.9474 24.2809 90.9474 48C90.9474 71.7191 71.7191 90.9474 48 90.9474C24.2809 90.9474 5.05263 71.7191 5.05263 48ZM48 0C21.4904 0 0 21.4904 0 48C0 74.5096 21.4904 96 48 96C74.5096 96 96 74.5096 96 48C96 21.4904 74.5096 0 48 0ZM41.6675 55.7793L30.3155 44.4273L26.7428 48L39.8812 61.1384C40.8677 62.1249 42.4674 62.1249 43.4539 61.1384L68.9295 35.6627L65.3568 32.09L41.6675 55.7793Z"
  }));
}